<template>
	<div class="row px-4 table-wrapper">
		<table-lite
			:is-loading="table.isLoading"
			:columns="table.columns"
			:rows="table.rows"
			:total="table.totalRecordCount"
			:sortable="table.sortable"
			:messages="table.messages"
			@do-search="doSearch"
			@is-finished="tableLoadingFinish"
			:pageOptions="[ { value: 10, text: 10 }, { value: 25, text: 25 }, { value: 50, text: 50 }, { value: 100, text: 100 }, { value: 500, text: 500 }, { value: 1000, text: 1000 } ]"
		/>
	</div>
</template>
<script>
	import { inject, onMounted, reactive } from "vue";
	import { useRouter } from "vue-router";
	import toast from "@/config/toast";
	import API from "@/config/api";
	import TableLite from "vue3-table-lite";

	export default {
		name: "SightTable",
		components: {
			TableLite,
		},
		setup: () => {
			const store = inject("store");
			const masterStore = inject("masterStore");
			const router = useRouter();

			const data = reactive({
				fetched: false,
			});

			if (!store.state.auth.isAuth) router.push({ name: "Login" });

			const table = reactive({
				isLoading: false,
				columns: [
					{
						label: "City",
						field: "city.name",
						width: "8%",
						sortable: true,
						display: function (row) {
							return `<div><b>${row.city.name}</b></div>`;
						},
					},
					{
						label: "Activity",
						field: "activity",
						width: "8%",
						sortable: false,
					},
					{
						label: "Remark",
						field: "remarkOne",
						width: "8%",
						sortable: false,
					},
					{
						label: "Actions",
						field: "",
						width: "2%",
						sortable: false,
						display: function (row) {
							return `<div class="d-flex justify-content-around align-items-center">
                                
                                <button type="button" data-id="${row._id}"
                                 data-action="edit"
                                class="is-rows-el action-btn btn btn-warning">
                                <i class="bi bi-pencil-square"></i>
                                </button>
                                <button type="button" data-id="${row._id}"
                                 data-action="delete"
                                class="is-rows-el action-btn btn btn-danger"><i class="bi bi-trash"></i></button>
                                </div>`;
						},
					},
				],
				rows: [],
				totalRecordCount: 10,
				sortable: {
					sort: "desc",
				},
			});

			const getTags = async () => {
				try {
					const response = await API.privateRequest.get("sights?sort=desc");
					if (!response.data.data.length) return;
					masterStore.methods.changeData(response.data.data);
					table.rows = response.data.data;
					table.totalRecordCount = response.data.count;
					table.isLoading = false;
				} catch (err) {
					data.fetched = false;
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}

					toast.error(message, true);
				}
			};

			const doSearch = async (offset, limit, order, sort) => {
				try {
					table.isLoading = true;
					let url = "";
					if (offset) url = `${url}offset=${offset}&`;
					if (limit) url = `${url}limit=${limit}&`;
					if (order) url = `${url}order=${order}&`;
					if (sort) url = `${url}sort=${sort}`;

					const response = await API.privateRequest.get(`sights?${url}`);

					table.rows = response?.data.data;
					table.totalRecordCount = response?.data?.count;
					table.sortable.order = order;
					table.sortable.sort = sort;
					table.isLoading = false;
				} catch (err) {
					alert(err);
				}
			};

			const tableLoadingFinish = (elements) => {
				// console.log(document.querySelector(".quick-btn"));
				table.isLoading = false;

				Array.prototype.forEach.call(elements, function (element) {
					// if (element.classList.contains("name-btn")) {
					// 	element.addEventListener("click", function () {
					// 		console.log(this.dataset.id + " name-btn click!!");
					// 	});
					// }
					if (element.classList.contains("quick-btn")) {
						element.addEventListener("click", function () {
							changeStatus(this.dataset.id, this.dataset.status);
						});
					}
					if (element.classList.contains("action-btn")) {
						element.addEventListener("click", function () {
							changeComponent(this.dataset.id, this.dataset.action);
						});
					}
				});
			};

			const changeComponent = (id, action) => {
				id = id.trim();
				action = action.trim();
				try {
					if (action === "delete") {
						masterStore.methods.setId("delete", id);
						table.rows = table.rows.filter((row) => row._id !== id);
					} else if (action === "show") {
						masterStore.methods.changeComponent("view");
						masterStore.methods.changeData(
							table.rows.filter((row) => row._id === id)[0],
						);
					} else if (action === "edit") {
						masterStore.methods.setId("edit", id);
						masterStore.methods.changeData(
							table.rows.filter((row) => row._id === id)[0],
						);
						masterStore.methods.changeComponent("edit");
					}
				} catch (err) {
					console.log("error in UserTable actions");
				}
			};

			onMounted(() => getTags());

			return {
				masterStore,
				data,
				table,

				doSearch,
				tableLoadingFinish,
			};
		},
	};
</script>
<style scoped>
	::v-deep(.vtl-paging-info) {
		font-size: 0.8rem;
	}
	::v-deep(.vtl-paging-count-label),
	::v-deep(.vtl-paging-page-label) {
		padding-left: 1rem;
		padding-right: 0.4rem;
		font-size: 0.8rem;
	}
	::v-deep(.vtl-paging-pagination-div) {
		padding-bottom: 1rem;
		font-size: 0.8rem;
	}
	::v-deep(.vtl-tbody),
	::v-deep(.vtl-thead-th) {
		font-size: 0.8rem;
	}

	::v-deep(.vtl-tbody-td > div) {
		height: 100%;
	}

	::v-deep(.vtl-tbody-tr .vtl-tbody-td) {
		border: none;
	}
	::v-deep(.vtl-thead-tr) {
		border-bottom: 1px groove rgba(168, 167, 167, 0.442);
	}
	::v-deep(.vtl-thead-tr .vtl-thead-th) {
		background: rgb(255, 255, 255);
		color: #000;
		border: none;
	}
	::v-deep(.vtl-card) {
		padding: 0;
		border-radius: 20px;
		overflow: hidden;
	}
	::v-deep(.vtl-paging) {
		padding: 0 1rem;
	}
	.vtl-thead-td::nth-child(5) {
		background: red;
	}
</style>
